import { useAppStore } from '../../../../store/appStore';
import { extend, media, stylesheet } from 'typestyle';
import { Button, ButtonIcon } from '@traceair/tds';
import { DoubleArrowRightIcon } from '@traceair/webapp-icons';
import { BREAKPOINT_MEDIUM } from '../../../layout/styles';
import { useGuardUnsavedGcp } from '../../../../hooks/useGuardUnsavedGcp';

const css = stylesheet({
  container: {
    padding: '8px 24px',
    textAlign: 'right',
  },
  closeDesktop: media(
    { maxWidth: BREAKPOINT_MEDIUM },
    {
      display: 'none',
    },
  ),
  closeMobile: extend(
    {
      display: 'none',
    },
    media({ maxWidth: BREAKPOINT_MEDIUM }, { display: 'inline-flex' }),
  ),
});

export const MissionWindowShtorka = () => {
  const { setSelectedMission } = useAppStore();
  const withGcpUnsavedChangesGuard = useGuardUnsavedGcp();

  /**
   * Closes the current mission panel.
   * If there are unsaved GCP changes, a confirmation modal is shown first.
   * Uses the `withGcpUnsavedChangesGuard` wrapper to prevent accidental data loss.
   */
  const handleClick = withGcpUnsavedChangesGuard(() => {
    setSelectedMission(null);
  });

  return (
    <header className={css.container}>
      <ButtonIcon
        className={css.closeDesktop}
        style="tertiary"
        type="black"
        size="s"
        onClick={handleClick}
        icon={<DoubleArrowRightIcon />}
      />

      <Button text="Close" className={css.closeMobile} style="tertiary" type="black" size="s" onClick={handleClick} />
    </header>
  );
};
